import { render, staticRenderFns } from "./CollectionPerformanceExport.vue?vue&type=template&id=256fc876&scoped=true"
import script from "./CollectionPerformanceExport.vue?vue&type=script&lang=js"
export * from "./CollectionPerformanceExport.vue?vue&type=script&lang=js"
import style0 from "./CollectionPerformanceExport.vue?vue&type=style&index=0&id=256fc876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fc876",
  null
  
)

export default component.exports